import angular from 'angular';

(function() {
    'use strict';

    angular.module('app.prepasrel').controller('EditWorkflowCtrl', EditWorkflowCtrl);

    EditWorkflowCtrl.$inject = ['logger', '$state', '$translate', '$uibModal', 'AuthSvc', 'PrePasrelSvc', 'workflow'];

    /* @ngInject */
    function EditWorkflowCtrl(logger, $state, $translate, $uibModal, AuthSvc, PrePasrelSvc, workflow) {
        var vm = this;

        vm.includes = {
            errorMessages: require('../../app/layouts/error-messages.html')
        };

        vm.workflow = workflow;
        vm.isNew = vm.workflow.name === null;
        vm.isConsult = !vm.isNew && !AuthSvc.isAuthorized('CONFIGURATOR');
        vm.title = null;
        vm.form = null;
        vm.canDelete = canDelete;
        vm.save = save;
        vm.confirmDelete = confirmDelete;
        vm.gotoList = gotoList;

        activate();

        //Funtions
        function activate() {
            var titleKey = '';
            if (vm.isNew) {
                titleKey = 'prepasrel.workflow.edit.title-create';
            } else if (vm.isConsult) {
                titleKey = 'prepasrel.workflow.edit.title-consult';
            } else {
                titleKey = 'prepasrel.workflow.edit.title-edit';
            }
            vm.title = $translate.instant(titleKey) + (vm.isNew ? '' : ' ' + vm.workflow.name);
        }

        function canDelete() {
            return !vm.isNew && AuthSvc.isAuthorized('CONFIGURATOR');
        }

        function save() {
            if (vm.form.$valid) {
                var _workflow = prepareBeforeUpdate(vm.workflow);
                if (vm.isNew) {
                    PrePasrelSvc.createWorkflow(_workflow).then(
                        function() {
                            logger.success('prepasrel.workflow.status.created');
                            gotoList();
                        },
                        function(error) {
                            manageSaveError(error);
                        }
                    );
                } else {
                    PrePasrelSvc.updateWorkflow(_workflow).then(
                        function() {
                            logger.success('prepasrel.workflow.status.updated');
                            gotoList();
                        },
                        function(error) {
                            manageSaveError(error);
                        }
                    );
                }
            }
        }

        function manageSaveError(error) {
            if (error.status === 404) {
                logger.error('prepasrel.workflow.status.error_ftp_location');
            } else if (error.status === 409) {
                logger.error('prepasrel.workflow.status.error_alreadyexists', vm.workflow.name);
            } else {
                logger.error('error.generic');
            }
        }

        function gotoList() {
            $state.go('app.prepasrel.list-workflows');
        }

        function prepareBeforeUpdate(workflow) {
            var _workflow = angular.copy(workflow);
            delete _workflow.audit;
            delete _workflow.lastModification;
            return _workflow;
        }

        function confirmDelete() {
            $uibModal
                .open({
                    templateUrl: require('./confirm-delete.html'),
                    size: 'md'
                })
                .result.then(onConfirmDelete, function() {});
        }

        function onConfirmDelete() {
            PrePasrelSvc.deleteWorkflow(vm.workflow.name).then(
                function() {
                    logger.success('prepasrel.workflow.status.deleted');
                    gotoList();
                },
                function(/*error*/) {
                    logger.error('error.generic');
                }
            );
        }
    }
})();
